import React from 'react'

//
import { IconNew } from '../../storybook'

const ThankYouMessage = ({ title, text }) => (
  <div className="c-hubspot-form c-hubspot-form-thank-you">
    <IconNew
      classes="c-hubsport-form-message__icon c-hubsport-form-thank-you__icon"
      name="tabler-check"
      size={60}
    />
    <h4>{title}</h4>
    <p>{text}</p>
  </div>
)

export default ThankYouMessage
